// ------------------------------------
// Ação Formulário
// ------------------------------------
(function ($) {
  'use strict';

  // Formulários
  const $forms = $('.form-admin');
  // Mensagem de erro padrão
  const defaultErrorMessage = 'Não foi possível realizar esta operação.';

  // Percorre todos formulários da página
  $forms.each(function () {
    // Formulário
    const $form = $(this);
    // URL action
    const action = $form.attr('action');
    // Método de envio (POST/GET)
    const method = $form.attr('method');
    // Botão principal
    const $btnSubmit = $form.find('.btn-submit');
    // Texto padrão do botão principal
    let btnText;
    // Se o formulário deve ser limpo (resetado) após ser processado com sucesso
    const reset = !!$form.data('reset');
    // Exibe ou não o loader
    const formLoader = !!$form.data('show-loader');
    // Função callback customizada de sucesso
    const fnSuccessCb = $form.data('success-cb');
    // Função callback customizada de erro
    const fnErrorCb = $form.data('error-cb');
    // Função callback customizada pro before
    const fnBeforeCb = $form.data('before-cb');
    /* 
    Ação executada após o formulário ser processado com sucesso.
    padrão (sem parâmetro ou vazio): Apenas é exibida a mensagem de sucesso
    realod: A página é recarregada.
    redirect: O usuário é redirecionado para outra página (A página de retorno deveserá ser passada no campo oculto name='retorno')
    */
    const posAction = $form.data('pos');
    // Variável controladora para saber se messageo formulário está sendo processado
    let sending = false;

    // Fecha o modal em que o formulário se encontra (Se houver)
    function closeModalForm() {
      const $modal = $('#' + $form.data('modal'));
      if ($modal.length > 0) {
        $modal.modal('hide');
      }
    }

    // Retorna o formulário ao estado inicial (Cadastro)
    function resetForm(clearInputs = false) {
      sending = false;
      $btnSubmit.prop('disabled', false).html(btnText);
      if (clearInputs && reset) {
        resetFormInputs($form);
      }
    }

    // Redireciona a página (Apenas se a opção 'pos' seja 'redirect')
    function redirectForm() {
      const urlRedirect = $form.find('input[name="retorno"]').val();
      if (!urlRedirect) {
        Toast.fire({
          type: 'warning',
          title: 'É necessário passar uma url de redirecionamento para o formulário.',
        });
        return false;
      }
      location.href = urlRedirect;
    }

    // Ações executadas antes e enquanto o formulário é processado
    function sendingForm() {
      sending = true;
      btnText = $btnSubmit.html();
      $btnSubmit.prop('disabled', true).html('<div class="btn-spinner"></div> Aguarde');
      if (formLoader) {
        showLoader();
      }
      // Executa a função de callback (Se houver)
      if (typeof window[fnBeforeCb] === 'function') {
        window[fnBeforeCb].call(null);
      }
    }

    // Ações executadas quando o form é processado com sucesso
    function successForm(resp) {
      console.log(resp);
      resetForm();
      try {
        resp = JSON.parse(resp);
        // Sucesso
        if (resp.status == 'success') {
          if ($('.tab-alert').length > 0) {
            window.removeEventListener('beforeunload', windowAlertReload);
          }
          closeModalForm();
          resetForm(reset);
          // Recarrega a página
          if (posAction === 'reload') {
            location.reload();
          }
          // Redireciona
          else if (posAction === 'redirect') {
            redirectForm();
          }
          // Executa a função de callback (Se houver)
          else if (typeof window[fnSuccessCb] === 'function') {
            window[fnSuccessCb].call(null, resp);
          }
          // Padrão (Exibe mensagme do retorno)
          else {
            if (formLoader) {
              hideLoader();
            }
            Toast.fire({
              type: 'success',
              title: resp.mensagem,
            });
          }
        }
        // Erro
        else {
          if (formLoader) {
            hideLoader();
          }
          // Executa a função de callback (Se houver)
          if (typeof window[fnErrorCb] === 'function') {
            window[fnErrorCb].call(null);
          }
          if (resp.status == 'warning') {
            Toast.fire({
              type: 'warning',
              title: resp.mensagem,
            });
          } else {
            Toast.fire({
              type: 'error',
              title: resp.mensagem,
            });
          }
        }
      } catch (error) {
        console.log(error);
        if (formLoader) {
          hideLoader();
        }
        // Executa a função de callback (Se houver)
        if (typeof window[fnErrorCb] === 'function') {
          window[fnErrorCb].call(null);
        }
        Toast.fire({
          type: 'error',
          title: defaultErrorMessage,
        });
      }
    }

    // Ações executadas quando ocorre algum erro ao processar o form
    function errorForm(xhr, status, exception) {
      console.log(exception);
      resetForm();
      if (formLoader) {
        hideLoader();
      }
      // Executa a função de callback (Se houver)
      if (typeof window[fnErrorCb] === 'function') {
        window[fnErrorCb].call(null);
      }
      Toast.fire({
        type: 'error',
        title: defaultErrorMessage,
      });
    }

    // Fix para os campos com validação remota
    $form.find('[data-parsley-remote]').each(function () {
      $(this)
        .parsley()
        .on('field:validate', function () {
          if (!sending) {
            $btnSubmit.prop('disabled', true);
          }
        })
        .on('field:validated', function () {
          if (!sending) {
            $btnSubmit.prop('disabled', false);
          }
        });
    });

    // Envia o formulário
    $form.on('submit', function (ev) {
      ev.preventDefault();
      if (!sending) {
        // Verifica se tem recaptcha e adiciona o token
        if (
          $form.hasClass('enable-recaptcha') &&
          typeof grecaptcha !== 'undefined' &&
          typeof recaptchaKey !== 'undefined'
        ) {
          recaptchaGenerateToken(
            $form,
            function () {
              const formData = new FormData($form[0]);
              $.ajax({
                url: action,
                type: method,
                data: formData,
                contentType: false,
                cache: false,
                processData: false,
                beforeSend: sendingForm,
                success: successForm,
                error: errorForm,
              });
            },
            resetForm,
          );
          return;
        }

        // Envio sem recaptcha
        const formData = new FormData($form[0]);
        $.ajax({
          url: action,
          type: method,
          data: formData,
          contentType: false,
          cache: false,
          processData: false,
          beforeSend: sendingForm,
          success: successForm,
          error: errorForm,
        });
      }
    });
  });
})(jQuery);

// Retorna o formulário ao estado inicial (Cadastro)
function resetFormInputs($form) {
  // Campos padrões (Não são resetados)
  const ignoredFields = ['token', 'acao', 'retorno'];
  $form.find('.form-control').each(function () {
    const $input = $(this);
    const inputName = $input.attr('name');
    // Ignora os campo padrões
    if (ignoredFields.indexOf(inputName) === -1) {
      $input.val('');
    }
  });
  // Reseta os checkbox e radios
  $form.find('[type="checkbox"], [type="radio"]').prop('checked', false);
  // Marca o padrão (checkbox e radios)
  $form.find('[data-checked-default]').prop('checked', true);
  // Reseta para o valor padrão do input
  $form.find('[data-input-default]').each(function () {
    $(this).val($(this).data('input-default')).trigger('change');
  });
  // Selecione o primeiro item dos campos select
  $form.find('select.form-control').each(function () {
    $(this).val($(this).find('option').first().val());
  });
  // Reseta campos do plugin Select2
  $form.find('.select2').each(function () {
    $(this).val(null).trigger('change');
  });
  // Restaura a permissão dos campos de senha
  $form.find('[type="password"]').prop('required', true);
  // Reseta as labels dos campos de arquivos
  $form.find('.custom-file-label').text('Selecionar arquivo');
  // Reseta o validador
  $form.parsley().reset();
}

// ------------------------------------
// Recaptcha
// ------------------------------------

// Variáveis
const recaptchaKey = $('#infos-base').data('recaptchakey');

// Carrega o Recaptcha (Caso algum form seja encontrado)
if ($('form.enable-recaptcha').length > 0 && typeof recaptchaKey !== 'undefined') {
  $('form.enable-recaptcha [type="submit"]').each(function () {
    $(this).prop('disabled', true);
  });
  setTimeout(() => {
    loadScript(`https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`, function () {
      $('form.enable-recaptcha [type="submit"]').each(function () {
        $(this).prop('disabled', false);
      });
    });
  }, 1500);
}

// Gera token de envio do recaptcha
function recaptchaGenerateToken($form, cbSuccess, cbFail = false) {
  if ($form.length === 0) {
    return false;
  }
  grecaptcha.ready(function () {
    grecaptcha.execute(recaptchaKey, { action: 'submit' }).then(function (token) {
      if (token) {
        if (!$form.find('input[name="g-recaptcha-response"]').length) {
          $form.append(`<input type="hidden" name="g-recaptcha-response" value="${token}">`);
          $form.append(`<input type="hidden" name="enable-recaptcha" value="1">`);
        } else {
          $form.find('input[name="g-recaptcha-response"]').val(token);
          $form.find('input[name="enable-recaptcha"]').val(1);
        }
        cbSuccess();
      } else {
        console.log('Não foi possível gerar o token do recaptcha.', token);
        if (cbFail !== false) {
          cbFail();
        }
      }
    });
  });
}
